<template>
  <CommonVCard v-show="false" id="fans_and_followers">
    <h2 class="registration-form__header mb-4">
      {{ $t("player_registration.fans_and_followers") }}
    </h2>
    <p class="font-weight-medium">
      {{ $t("player_registration.fans_and_followers_text") }}
    </p>
    <ul v-if="isRenderFansAndFollowers" class="my-7">
      <FanOrFollowerListItem
        v-for="item in fansOrFollowers"
        :key="item.id"
        :changeItem="handleChangeFanOrFollower"
        :fansOrFollowers="fansOrFollowers"
        :isAnyFanOrFollowerListItemEditable="isAnyFanOrFollowerListItemEditable"
        :item="item"
      />
    </ul>
    <div v-else class="d-flex justify-center mb-4">
      <v-progress-circular color="primary" indeterminate></v-progress-circular>
    </div>
    <div class="d-flex justify-center">
      <CommonButton
        :disabled="
          !playerRegistration.value ||
            isAnyFanOrFollowerListItemEditable ||
            !isRenderFansAndFollowers
        "
        :label="$t('player_registration.add_fan/follower')"
        @handleClick="handleAddFanOrFollower"
      />
    </div>
  </CommonVCard>
</template>

<script>
import CommonVCard from "./CommonVCard";
import FanOrFollowerListItem from "./FanOrFollowerListItem";
import CommonButton from "../common/CommonButton";
import { mapGetters } from "vuex";
import { ModuleTypes } from "../../../store/ModuleTypes";
import GetterTypes from "@/store/GetterTypes";

export default {
  name: "PlayerRegistrationFormFansAndFollowersCard",
  components: { CommonButton, CommonVCard, FanOrFollowerListItem },
  data: () => ({
    fansOrFollowers: []
  }),

  computed: {
    ...mapGetters(ModuleTypes.PLAYER_REGISTRATION, [
      "playerRegistrationDetails",
      "playerRegistration"
    ]),

    ...mapGetters({
      user: GetterTypes.GET_USER
    }),

    isRenderFansAndFollowers() {
      return Array.isArray(this.fansOrFollowers);
    },

    isAnyFanOrFollowerListItemEditable() {
      return this.fansOrFollowers.some(item => item.isEditable);
    }
  },
  methods: {
    handleAddFanOrFollower() {
      this.fansOrFollowers.push({
        email: "",
        fanType: "",
        isEditable: true,
        isNewItem: true,
        registeredUser: false
      });
    },

    handleChangeFanOrFollower(item, updatedItem = null) {
      const index = this.fansOrFollowers.findIndex(
        el => el.email === item.email
      );
      if (index !== -1) {
        this.fansOrFollowers.splice(
          index,
          1,
          ...(updatedItem !== null
            ? [{ ...updatedItem, isNewItem: !!item.isNewItem }]
            : [])
        );
      }
    }
  },
  watch: {
    playerRegistrationDetails: {
      handler: function(newValue) {
        if (!newValue || !newValue.fansAndFollowersList) {
          this.fansOrFollowers = [
            {
              email: this.user.username,
              fanType: "FAN",
              isEditable: false,
              isNewItem: false,
              registeredUser: true,
              isReadOnly: true
            }
          ];
          return;
        }
        this.fansOrFollowers = newValue.fansAndFollowersList.map(
          ({ email, fanType, registeredUser }) => ({
            email,
            fanType,
            registeredUser,
            isNewItem: false,
            isEditable: false
          })
        );
      },
      immediate: true
    }
  }
};
</script>

<style scoped>
.registration-form__header {
  font-size: 18px;
  font-weight: 500;
  color: var(--dark-color);
}
</style>
